import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ResourceColumn, ResourceListPage } from '../../components/resource/ResourceListPage';
import { KPI } from '../../types/indicadores';
import { kpiService } from '../../services';

const columns: ResourceColumn<KPI>[] = [
  { header: "Nome", accessor: "nome" },
  { header: "Unidade", accessor: "unidade" },
  { header: "Meta", accessor: "meta_valor" },
  { header: "Fórmula", render: (item) => item.formula },
  { header: "Descrição", render: (item) => item.descricao }
];

export const KpisListPage: React.FC = () => {
  const navigate = useNavigate();

  return (
  <ResourceListPage
    title="KPIs"
    description="Indicadores chave monitorados."
    columns={columns}
    service={kpiService}
    createPath="/admin/indicadores/kpis/novo"
      onEdit={(item) => item.id && navigate("/admin/indicadores/kpis/editar", { state: { record: item } })}
  />
  );
};